export default "__VITE_ASSET__D0s3ffXh__"